<template>
    <section>
        <PageTitle title="All Coupons" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/coupons',title:'coupons'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">All Coupons</h5>
                        <a v-if="userRole!=='ROLE_AGENT' && userRole!=='ROLE_MANAGER'" v-on:click="loadEmptyCoupon()" class="pull-right" >Add New Coupons</a>
                    </div>
                    <div class="ibox-content">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Restaurant</label>
                                    <multiselect id="filter2" v-model="selectedRestaurant" :options="restaurants" label="name" track-by="name"></multiselect>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>In Percentage</label>
                                    <multiselect id="filter4" v-model="InPercentage" :options="options" label="name" track-by="name"></multiselect>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>One Time Coupon</label>
                                    <multiselect id="filter5" v-model="IsOneTime" :options="options" label="name" track-by="name"></multiselect>
                                </div>
                            </div>
                            <div class="col-md-3">
                              <search-coupon-by-coupon-code
                                  ref="searchCouponByWildCard"
                                  @selectedCoupon="fetchSelectedCoupon"
                              />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Start Date</label>
                                    <input id="filter7" type="text" readonly="readonly" placeholder="Search By Date" class="form-control date_picker"/>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>End Date</label>
                                    <input id="filter8" type="text" readonly="readonly" placeholder="Search By Date" class="form-control date_picker"/>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Created</label>
                                    <input id="filter9" type="text" readonly="readonly" placeholder="Search By Date Range" class="form-control date_picker"/>
                                </div>
                            </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>Redeemed</label>
                              <multiselect id="filter6" v-model="redeemed" :options="options" label="name" track-by="name"></multiselect>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_order_btn"><i class="fa fa-search"></i> Search</button>
                                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_order_btn"><i class="fa fa-refresh"></i> Refresh</button>
                            </div>
                        </div>
                        <hr/>
                        <div class="table-responsive">
                            <table class="table table-striped table-responsive table-bordered table-hover" id="dtTable">
                                <thead>
                                    <tr>
                                        <th>Coupon ID</th>
                                        <th>Code</th>
                                        <th>Restaurant</th>
                                        <th>Discount</th>
                                        <th>In Percentage</th>
                                        <th>One Time</th>
                                        <th>Status</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Created</th>
                                        <th>Modified</th>
                                        <th class="text-center"><i class="fa fa-bolt"></i></th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ViewCustomerAddresses where="customers" ref="viewCustomerAddressPopUp"/>
        <AddUpdateCoupon ref="addUpdateCouponPopUp"/>
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import ViewCustomerAddresses from '@/components/customers/ViewCustomerAddresses'
    import AddUpdateCoupon from '@/components/coupons/AddUpdateCoupon'
    import Multiselect from 'vue-multiselect'
    import SearchCouponByCouponCode from "@/components/utils/SearchCouponByCouponCode";
    import User from '@/services/User'

    export default {
        name: "Riders",
        components: {
          PageTitle,
          ViewCustomerAddresses,
          AddUpdateCoupon,
          Multiselect,
          SearchCouponByCouponCode,
        },
        data() {
            return {
                selectedRestaurant:null,
                InPercentage: null,
                IsOneTime: null,
                redeemed: null,
                options: [
                    {id:1,name:'Yes'},{id:0,name: 'No'}
                ],
                restaurants:[],
                table:'',
                userRole:'',
                selectedCouponTemp: null
            }
        },
        mounted: function (){
                let user = this.$store.state.user;
                this.userRole = user.userRolesById[0].role;
                if(this.userRole === 'ROLE_ADMIN' || this.userRole==='ROLE_AGENT' || this.userRole==='ROLE_MANAGER'){
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                        this.restaurants = resp.data;
                    });
                }else if(this.userRole === 'ROLE_USER'){
                    this.selectedRestaurant = this.$store.state.user.restaurant;
                    this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name});
                }
                console.log(this.where);

            let self = this;
            let processingURL = this.$store.state.mainAppURL + "restaurants/get_all_coupons";
            let dtTable = $('#dtTable').DataTable({
                "dom": 'lrtip',
                "processing": true,
                "serverSide": true,
                "scrollX": true,
                "searching": true,
                autoWidth: false,
                "lengthMenu": [10, 25, 50, 100, 250],
                "initComplete": function () {
                var api = this.api();
                if ( self.userRole==='ROLE_AGENT' || self.userRole==='ROLE_MANAGER' ) {
                    api.column(11).visible( false );
                }},
                "order": [[0, "desc"]],
                'language': {
                    //'loadingRecords': 'Please wait - loading...',
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                        if (user.userRolesById[0].role==="ROLE_USER"){
                            Object.assign(d, {restaurant_id: user.restaurant.id});
                        }
                        return JSON.stringify( d );
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr) => {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(dtTable);
                      }
                    },
                },
                "columnDefs": [
                    { "orderable": false, "targets": [1,2,4,5,6,11] },
                    { 'className': "text-center", 'aTargets': [0,1,2,3,4,5,6,7,8,9,10,11]},
                ],
                "columns": [
                    { "data": "id", "name":"id" },
                    { "data": "couponCode","name":"couponCode" },
                    {
                        "data": "restaurantsByRestaurantId","name":"restaurantsByRestaurantId",
                        "render": function(data){
                            return (data === null) ? "N/A" : data.name;
                        }
                    },
                    { "data": "discount","name":"discount" },
                    {
                        "data": "inPercentage","name":"inPercentage",
                        "render": function(data){
                            if(data){
                                return "<label class='label label-success'>Yes</label>"
                            }else{
                                return "<label class='label label-danger'>No</label>"
                            }
                        }
                    },
                    {
                        "data": "oneTime","name":"isOneTime",
                        "render": function(data){
                            if(data){
                                return "<label class='label label-success'>Yes</label>"
                            }else{
                                return "<label class='label label-danger'>No</label>"
                            }
                        }
                    },
                    {
                        "data": "redeemed","name":"isRedeemed",
                        "render": function(data, type, row){
                          let isExpire = self.$moment(row.endDate).isBefore(self.$moment())
                          return data ? "Redeemed" : isExpire ? "Expired" : "Available";
                        }
                    },
                    {
                        "data": "startDate","name":"startDate",
                        "render": function (data) {
                            return "<span class='m_tip label label-default' title='"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"'>"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"</span>";
                        }
                    },
                    {
                        "data": "endDate","name":"endDate",
                        "render": function (data) {
                            return "<span class='m_tip label label-default' title='"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"'>"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"</span>";
                        }
                    },
                    {
                        "data": "created",
                        "name":"created",
                        "render": function (data) {
                            return "<span class='m_tip label label-default' title='"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"'>"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"</span>";
                        }
                    },
                    {
                        "data": "modified",
                        "name":"modified",
                        "render": function (data) {
                            return "<span class='m_tip label label-default' title='"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"'>"+self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY hh:mm:ss A')+"</span>";
                        }
                    },
                    {
                        "data": "action","name":"action",
                        "render": function(data, type, row){
                            return "<a data-id='"+row.id+"' class='deleteCouponBtn'>Delete Coupon</a>";
                        }
                    }
                ],
                "drawCallback": function( settings ) {
                    $(".m_tip").tooltip();
                    $(".deleteCouponBtn").click(function () {
                        let couponId = $(this).attr("data-id");
                        Swal({
                            title: 'Are you sure?',
                            text: "Are you sure you want to delete this coupon!",
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#1ab394',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, delete it!'
                        }).then((result) => {
                            if (result.value) {
                                self.$http.delete( self.$store.state.mainAppURL + "restaurants/delete_coupon_by_id/"+couponId).then(resp => {
                                    Swal.close();
                                    if(resp.data){
                                        dtTable.draw();
                                        swal("SUCCESS!", "Coupon has been deleted successfully!", "success");
                                    }else{
                                        swal("Error!", "Please try again!", "error");
                                    }
                                }).catch(ex => {
                                    swal("Error!", ex + "Please try again!!", "error");
                                });
                            }
                        });
                    });
                },
                "tableTools": {
                    "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
                }
            });
            this.table = dtTable;
            $.fn.dataTable.ext.errMode = 'none';
            $(".search_filter_order_btn").click(function(){
                dtTable.search('');
                for(let i = 1; i <= 9; i++){
                  if (i === 1){
                    dtTable.column(i).search(self.selectedCouponTemp ? self.selectedCouponTemp.id : "");
                  } else if (i === 2 && self.selectedRestaurant !== null){
                        dtTable.column(i).search(self.selectedRestaurant.name);
                    } else if (i === 4 && self.InPercentage !== null){
                        dtTable.column(i).search(self.InPercentage.id);
                    }else if (i === 5 && self.IsOneTime !== null){
                        dtTable.column(i).search(self.IsOneTime.id);
                    }else if (i===6 && self.redeemed !== null){
                        dtTable.column(i).search(self.redeemed.id);
                    }
                    else {
                        dtTable.column(i).search($("#filter" + i).val());
                    }
                    $("#filter" + i).val( '' );
                }
                dtTable.draw();
                self.selectedRestaurant = ''
                self.InPercentage = null
                self.IsOneTime = null
                self.redeemed = null
            });
            $(".refresh_filter_order_btn").click(function() {
                for(let i=1; i <= 9; i++){
                    $("#filter" + i).val( '' );
                    dtTable.column(i).search( '' );
                }
                dtTable.search('');
                dtTable.draw();
                self.selectedRestaurant = '';
                self.InPercentage = null
                self.IsOneTime = null
                self.redeemed = null
                self.$refs.searchCouponByWildCard.selectedCouponTemp = null
            });
            $('.date_picker').daterangepicker({
                format: 'YYYY-MM-DD',
            }).on('apply.daterangepicker', function(ev, picker) {
                $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
            }).on('cancel.daterangepicker', function(ev, picker) {
                $(this).val('');
            });
        },
        methods: {
          fetchSelectedCoupon(val) {
            this.selectedCouponTemp = val
          },
          tableDraw: function () {this.table.draw()},
          loadEmptyCoupon: function () {
              this.$refs.addUpdateCouponPopUp.load();
          }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
